export default __webpack_public_path__ + "static/media/NR-BX421GUS01.473e68cf.jpg";